import React from 'react';
import { useMutation, gql } from '@apollo/client';
import Signup from '../../components/StudentPlatform/pages/Signup';

const CREATE_STUDENT_ACCOUNT = gql`
  mutation CreateStudentAccount(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $age: Int
    $phone: String
    $city: String
    $state: String
    $school: String
    $degreeProgram: String
    $graduationYear: Int
  ) {
    createStudentAccount(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      age: $age
      phone: $phone
      city: $city
      state: $state
      school: $school
      degreeProgram: $degreeProgram
      graduationYear: $graduationYear
    ) {
      user {
        id
        name
        email
      }
      studentProfile {
        id
        profileCompleted
      }
      token
    }
  }
`;

const SignupContainer = () => {
  const [createStudentAccount, { loading, error }] = useMutation(CREATE_STUDENT_ACCOUNT);

  const handleComplete = async (formData) => {
    try {
      // Convert availability array to object format
      const availabilityObj = {};
      formData.availability.forEach((season) => {
        availabilityObj[season] = true;
      });

      const { data } = await createStudentAccount({
        variables: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          password: formData.password,
          age: parseInt(formData.age),
          phone: formData.phone,
          city: formData.city,
          state: formData.state,
          school: formData.school,
          degreeProgram: formData.degreeProgram,
          graduationYear: parseInt(formData.graduationYear),
        },
      });

      if (data?.createStudentAccount?.token) {
        // Store token and redirect to dashboard
        localStorage.setItem('authToken', data.createStudentAccount.token);
        window.location.href = '/student/dashboard';
      }
    } catch (err) {
      console.error('Signup error:', err);
      alert('Signup failed. Please try again.');
    }
  };

  return <Signup onComplete={handleComplete} loading={loading} error={error} />;
};

export default SignupContainer;

